// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D2fJoN {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: var(--surface-neutral-white);
  position: relative;
  box-sizing: border-box;
  gap: 24px;
  text-align: left;
  font-size: 14px;
  color: var(--text-neutral-dark);
  font-family: var(--font-family-base);
}

.uWqfvc {
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.KMewTD {
  width: 100%;
  height: 1px;
  background-color: #e6e6e6;
  margin: 0;
  padding: 0;
}
.yM17Xq {
  font-weight: 600;
  font-family: var(--font-family-base);
  color: var(--text-neutral-dark);
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  font-size: 14px;
  line-height: 1.8em;
}

.SOQHRs {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.d4_YHc {
  font-size: var(--type-label-md-font-size, 14px);
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular, 400);
  margin: 0;
  padding: 0;
}

.ria5dI {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.zKE1Hz {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--spacing-1-5, 12px);
}

._yWCDK {
  width: 50%;
}

.JzKFMV {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  gap: var(--spacing-1-5, 12px);
}

.ulyLIY {
  width: 50%;
  min-height: 95px;
}

.XAFv4c {
  width: 100% !important;
  height: var(--input-height, 40px) !important;
  border-radius: var(--radius-m, 4px);
}

.BAin_6 {
  width: 100% !important;
  height: var(--input-height, 40px) !important;
  border-radius: var(--radius-m, 4px);
  border: 1px solid transparent !important;
  background: transparent !important;
  font-size: var(--font-size-md, 14px) !important;
  color: var(--text-neutral-dark) !important;
  outline: none !important;
  transition: border 0.2s !important;
  font-family: var(--font-family-base) !important;
}

.BAin_6:focus {
  border-color: var(--surface-primary-medium, #d64000) !important;
  outline-offset: var(--spacing-0, 0) !important;
}

.RRogLR {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;
  gap: var(--spacing-2, 16px);
  background-color: var(--surface-neutral-white);
  padding: 15px 0 0 0;
}

.d7AwDP {
  min-width: 100px;
}

.rZm8qs {
  width: 100%;
}

/* Responsividade para telas menores */
@media (max-width: 768px) {
  .D2fJoN {
    padding: 16px;
    gap: 16px;
  }

  .uWqfvc {
    gap: 16px;
  }

  .SOQHRs {
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/PixTransferSelectKeyType/PixTransferSelectKeyType.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,+BAA+B;EAC/B,4CAA4C;EAC5C,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,mCAAmC;EACnC,wCAAwC;EACxC,kCAAkC;EAClC,+CAA+C;EAC/C,0CAA0C;EAC1C,wBAAwB;EACxB,kCAAkC;EAClC,+CAA+C;AACjD;;AAEA;EACE,+DAA+D;EAC/D,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,2BAA2B;EAC3B,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background-color: var(--surface-neutral-white);\n  position: relative;\n  box-sizing: border-box;\n  gap: 24px;\n  text-align: left;\n  font-size: 14px;\n  color: var(--text-neutral-dark);\n  font-family: var(--font-family-base);\n}\n\n.content {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.divider {\n  width: 100%;\n  height: 1px;\n  background-color: #e6e6e6;\n  margin: 0;\n  padding: 0;\n}\n.title {\n  font-weight: 600;\n  font-family: var(--font-family-base);\n  color: var(--text-neutral-dark);\n  display: flex;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  font-size: 14px;\n  line-height: 1.8em;\n}\n\n.inputSection {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  width: 100%;\n}\n\n.label {\n  font-size: var(--type-label-md-font-size, 14px);\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular, 400);\n  margin: 0;\n  padding: 0;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.agencyAccountWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-1-5, 12px);\n}\n\n.agencyAccountField {\n  width: 50%;\n}\n\n.nameIdentifierWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: var(--spacing-1-5, 12px);\n}\n\n.nameIdentifierField {\n  width: 50%;\n  min-height: 95px;\n}\n\n.inputContainer {\n  width: 100% !important;\n  height: var(--input-height, 40px) !important;\n  border-radius: var(--radius-m, 4px);\n}\n\n.input {\n  width: 100% !important;\n  height: var(--input-height, 40px) !important;\n  border-radius: var(--radius-m, 4px);\n  border: 1px solid transparent !important;\n  background: transparent !important;\n  font-size: var(--font-size-md, 14px) !important;\n  color: var(--text-neutral-dark) !important;\n  outline: none !important;\n  transition: border 0.2s !important;\n  font-family: var(--font-family-base) !important;\n}\n\n.input:focus {\n  border-color: var(--surface-primary-medium, #d64000) !important;\n  outline-offset: var(--spacing-0, 0) !important;\n}\n\n.footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  gap: var(--spacing-2, 16px);\n  background-color: var(--surface-neutral-white);\n  padding: 15px 0 0 0;\n}\n\n.button {\n  min-width: 100px;\n}\n\n.releaseTypeAndValueContainer {\n  width: 100%;\n}\n\n/* Responsividade para telas menores */\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n    gap: 16px;\n  }\n\n  .content {\n    gap: 16px;\n  }\n\n  .inputSection {\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `D2fJoN`,
	"content": `uWqfvc`,
	"divider": `KMewTD`,
	"title": `yM17Xq`,
	"inputSection": `SOQHRs`,
	"label": `d4_YHc`,
	"inputWrapper": `ria5dI`,
	"agencyAccountWrapper": `zKE1Hz`,
	"agencyAccountField": `_yWCDK`,
	"nameIdentifierWrapper": `JzKFMV`,
	"nameIdentifierField": `ulyLIY`,
	"inputContainer": `XAFv4c`,
	"input": `BAin_6`,
	"footer": `RRogLR`,
	"button": `d7AwDP`,
	"releaseTypeAndValueContainer": `rZm8qs`
};
module.exports = ___CSS_LOADER_EXPORT___;
